// Widoczność warunkowa: wrappery [data-show-when="pole=a|b"], grupy ROZSZ
// [data-rozsz] i checkbox wykluczający [data-exclusive] (pole 25).
//
// Zasada: hidden steruje widocznością, a disabled na inputach wewnątrz
// ukrytych wrapperów wyłącza je z walidacji i z FormData. Stan liczony
// zawsze od zera (settle), więc zagnieżdżenia (cond w ROZSZ) działają same.

import { announce } from "./a11y.js";
import { clearFieldError } from "./validate.js";

export function initConditionals(form, options = {}) {
    const wrappers = Array.from(form.querySelectorAll("[data-show-when]"));
    const rozszWrappers = Array.from(form.querySelectorAll("[data-rozsz]"));
    // segmented control: dwie opcje tego samego zestawu pytań (MIN domyślnie)
    const rozszOpts = Array.from(form.querySelectorAll("[data-rozsz-set]"));
    let rozszOn = false;

    function fieldValue(name) {
        const checked = form.querySelector('input[name="' + CSS.escape(name) + '"]:checked');
        if (checked) return checked.value;
        const field = form.querySelector('[name="' + CSS.escape(name) + '"]');
        if (!field) return "";
        if (field.type === "radio" || field.type === "checkbox") return "";
        return field.value || "";
    }

    function ruleMet(rule) {
        const [name, values] = rule.split("=");
        if (!name || values === undefined) return false;
        return values.split("|").includes(fieldValue(name));
    }

    function settle() {
        wrappers.forEach((wrapper) => {
            wrapper.hidden = !ruleMet(wrapper.dataset.showWhen);
        });
        rozszWrappers.forEach((wrapper) => {
            wrapper.hidden = !rozszOn;
        });
        form.querySelectorAll("[data-rozsz-hide]").forEach((el) => {
            el.hidden = rozszOn;
        });

        // disabled = jakikolwiek ukryty wrapper nad polem
        form
            .querySelectorAll("[data-show-when] input, [data-show-when] textarea, [data-rozsz] input, [data-rozsz] textarea")
            .forEach((input) => {
                const hiddenAncestor = input.closest("[data-show-when][hidden], [data-rozsz][hidden]");
                const nowDisabled = !!hiddenAncestor;
                if (nowDisabled && !input.disabled) clearFieldError(input);
                input.disabled = nowDisabled;
                if (input.hasAttribute("data-required-when-visible")) {
                    input.required = !nowDisabled;
                }
            });

        if (options.onSettle) options.onSettle(rozszOn);
    }

    function setRozsz(on, announceIt) {
        rozszOn = on;
        rozszOpts.forEach((btn) => {
            btn.setAttribute("aria-pressed", (btn.dataset.rozszSet === "rozsz") === on ? "true" : "false");
        });
        const versionInput = form.querySelector('input[name="wersja"]');
        if (versionInput) versionInput.value = on ? "rozsz" : "min";
        settle();
        if (announceIt) {
            announce(on ? "Dodatkowe pytania włączone." : "Dodatkowe pytania ukryte.");
        }
    }

    rozszOpts.forEach((btn) => {
        btn.addEventListener("click", () => setRozsz(btn.dataset.rozszSet === "rozsz", true));
    });
    form.querySelectorAll("[data-rozsz-open]").forEach((btn) => {
        btn.addEventListener("click", () => setRozsz(true, true));
    });

    // checkbox wykluczający („Nie wiem — zaproponujcie")
    form.addEventListener("change", (event) => {
        const input = event.target;
        if (input.type === "checkbox" && input.name.endsWith("[]")) {
            const group = form.querySelectorAll('input[name="' + CSS.escape(input.name) + '"]');
            const exclusive = Array.from(group).find((el) => el.hasAttribute("data-exclusive"));
            if (!exclusive) return;
            if (input === exclusive && input.checked) {
                group.forEach((el) => {
                    if (el !== exclusive) el.checked = false;
                });
            } else if (input.checked) {
                exclusive.checked = false;
            }
        }
        settle();
    });

    settle();

    return {
        settle,
        setRozsz,
        isRozsz: () => rozszOn,
    };
}
